<template>
<div class="chapter">
<div class="inner_page">
<div class="inline_groupc"><img alt="Image" class="landscape" src="images/part.jpg"/></div>
<hr class="hrt"/>
<h2 class="h2p"><a id="page_5">Part I</a></h2><a id="page_5">
<hr class="hrb"/>
</a><h2 class="h2p-sub"><a id="page_5">Tangent to the Circle of Life</a><a id="page_6"></a></h2><a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?dc097bae